import React from "react";
import FormikCustomInput from '../formikCustomInput';
import Radio from "./components/radio";

export interface IFormikRadioInputProps {
  name: string;
  label: string | any;
  form?: any;
  field?: any;
  okMode?: boolean;
  flip?: boolean;
  labelInMiddleMode?: boolean;
}


const FormikRadioInput = ({...props}: IFormikRadioInputProps) => (
  <FormikCustomInput
    {...props}
    hideLabel={props.labelInMiddleMode}
    inputComponent={inputProps => <Radio
      {...inputProps}
      okMode={inputProps.okMode}
      setState={(state) => inputProps.form.setFieldValue(inputProps.field.name, inputProps.flip ? !state : state)}
      state={inputProps.flip ? !inputProps.field.value : inputProps.field.value}
      labelInMiddleMode={props.labelInMiddleMode}
    />}
  />
);

FormikRadioInput.defaultProps = {
  name: "",
  label: "",
  okMode: false,
  labelInMiddleMode: false,
};

export default FormikRadioInput;
